/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ProjectTypesControllerFindAllQueryResponse, ProjectTypesControllerFindAllQueryParams, ProjectTypesControllerFindAll401, ProjectTypesControllerFindAll403 } from "../../models/projectTypesController/ProjectTypesControllerFindAll";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { projectTypesControllerFindAll } from "../../clients/project-typesService/projectTypesControllerFindAll";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const projectTypesControllerFindAllQueryKey = (params: ProjectTypesControllerFindAllQueryParams = {}) => [{
  url: '/api/v1/project-types'
}, ...(params ? [params] : [])] as const;
export type ProjectTypesControllerFindAllQueryKey = ReturnType<typeof projectTypesControllerFindAllQueryKey>;
export function projectTypesControllerFindAllQueryOptions(params?: ProjectTypesControllerFindAllQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = projectTypesControllerFindAllQueryKey(params);
  return queryOptions<ProjectTypesControllerFindAllQueryResponse, ResponseErrorConfig<ProjectTypesControllerFindAll401 | ProjectTypesControllerFindAll403>, ProjectTypesControllerFindAllQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return projectTypesControllerFindAll(params, config);
    }
  });
}

/**
 * @summary Get all project types
 * {@link /api/v1/project-types}
 */
export function useProjectTypesControllerFindAll<TData = ProjectTypesControllerFindAllQueryResponse, TQueryData = ProjectTypesControllerFindAllQueryResponse, TQueryKey extends QueryKey = ProjectTypesControllerFindAllQueryKey>(params?: ProjectTypesControllerFindAllQueryParams, options: {
  query?: Partial<QueryObserverOptions<ProjectTypesControllerFindAllQueryResponse, ResponseErrorConfig<ProjectTypesControllerFindAll401 | ProjectTypesControllerFindAll403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? projectTypesControllerFindAllQueryKey(params);
  const query = useQuery({
    ...projectTypesControllerFindAllQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ProjectTypesControllerFindAll401 | ProjectTypesControllerFindAll403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}